import e from"./PoweredBy.vue_vue&type=script&lang.js";import{render as r}from"./PoweredBy.vue_vue&type=template&id=3e8d7a5b&lang.js";e.render=r,e.__file="src/components/PoweredBy.vue";export default e;
//# sourceMappingURL=PoweredBy.vue.js.map
